import { Column } from "pages/Shared/interfaces"

export const banfNumber: Column = undefined
